export const shareTrialUtmParams = {
  utmCampaign: 'share_trial',
  utmSource: 'trial_listing',
}

export const shareYourStoryUtmParams = {
  utmCampaign: 'share_your_story',
  utmSource: 'post_trial_apply',
}
